import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import LoadingEmptyError from "components/LoaderEmptyErrorState";
import { recordSurveyFailure, surveyUpdate } from "data/slices/surveylist/api";
import keys from "locale/keys";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { STORAGE_USER_ID } from "utils/constants";
import { getFromLocalStorage, saveToLocalStorage } from "utils/Utils";

import AppLogo from "../../assets/icons/ApplogoBlack.svg";
import Button from "../../components/button/index";
import { AppLogoImg, Message, Wrapper } from "./styled.components";
import {
  getDynataStatusMessage,
  getFailurePayload,
  getRequestPayload,
  getTolunaStatusMessage,
  isDynata,
  isLucidMeasurement,
  isSurveySucccess,
  isToluna,
} from "./utils";

const SurveyCompletionRedirection = () => {
  const [params] = useSearchParams();
  const { pathname, search, hash } = useLocation();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccessRedirection, setIsSuccessRedirection] = useState(false);

  useEffect(() => {
    submitSurveyStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitSurveyStatus = async () => {
    setIsLoading(true);

    const isSuccess = await isSurveySucccess(pathname, params);
    setIsSuccessRedirection(isSuccess);

    const userId = getFromLocalStorage(STORAGE_USER_ID);
    const tolunaUrl = pathname + search + hash;
    const request = getRequestPayload(userId, pathname, params, tolunaUrl);
    if (request) {
      await surveyUpdate(request);
      if (!isSuccess) {
        const failurePayload = getFailurePayload(
          userId,
          params,
          pathname,
          tolunaUrl,
        );
        if (failurePayload) {
          await recordSurveyFailure(failurePayload);
        }
      }
    }

    setIsLoading(false);
  };

  const handleStartSurvey = () => {
    saveToLocalStorage("reload_surveys", Date.now().toString());
    setTimeout(() => {
      window.close();
    }, 100);
  };

  const getStatusIcon = () => {
    return isSuccessRedirection ? (
      <CheckCircleOutlineOutlinedIcon
        style={{ color: "green", width: "4rem", height: "4rem" }}
      />
    ) : (
      <CancelOutlinedIcon
        style={{ color: "red", width: "4rem", height: "4rem" }}
      />
    );
  };

  var message = isSuccessRedirection
    ? t(keys.survey_success_msg)
    : t(keys.survey_failure_msg);

  if (isToluna(pathname)) {
    // Here we are check is Toluna redirection or not.
    message = getTolunaStatusMessage(pathname, params);
  } else if (isDynata(params)) {
    message = getDynataStatusMessage(
      params.get("disposition")?.toLowerCase(),
      params.get("status")?.toLowerCase(),
      params.get("marketplace_status") ?? undefined,
      params.get("client_status") ?? undefined,
    );
  } else if (isLucidMeasurement(params)) {
    message = getDynataStatusMessage(
      "",
      "",
      params.get("ProofStatus") ?? undefined,
      params.get("ProofStatus") ?? undefined,
    );
  }

  return (
    <Wrapper>
      <AppLogoImg src={AppLogo} alt="app logo" />
      {getStatusIcon()}
      <Message>{message}</Message>
      {!isLoading && (
        <Button onClickHandler={handleStartSurvey}>
          {t(keys.go_to_surveys)}
        </Button>
      )}
      {isLoading && (
        <div>
          <LoadingEmptyError isLoading={true} isError={false} isEmpty={false} />
        </div>
      )}
    </Wrapper>
  );
};

export default SurveyCompletionRedirection;
